module.exports = __webpack_public_path__ + "static/media/oswalt.17fec797.jpg";